<div class="container" *ngIf="revisionInfo">
    <div class="tool-header">
        <h5>{{ revisionInfo?.toolName }} - {{ revisionInfo?.toolUid }}</h5>
        <span>{{
                ("admin.toolMaintenancePlans.revisionInfo.current" | translate) + ': ' +
                (revisionInfo.productionValue != 0 ?
                    RevisionUtils.computeRevisionTime(revisionInfo.planType, revisionInfo.productionValue, this.unit) + ' ' +
                    computeRecurrenceUnit() : 'N/A')
            }}</span>
    </div>

    <ng-container *ngIf="revisionInfo?.planType === ValueUnit.Time">
        <app-time-unit-picker (selectUnit)="onSelectUnit($event)">
        </app-time-unit-picker>
    </ng-container>

    <ng-container *ngFor="let operation of revisionInfo?.operations">
        <div class="operation-name">{{ operation.name }}</div>
        <ng-container *ngIf="operation.recurrences && operation.recurrences.length !=0 else noData" itemBody>
            <div class="recurrence" *ngFor="let recurrence of operation.recurrences">
                <span>{{ this.computeRecurrenceLabel(recurrence) }}</span>
            </div>
        </ng-container>
        <ng-template #noData>
            <span>{{ 'service.tickets.details.activityDetails.revisionInfoModal.noRevisionInfo' | translate }}</span>
        </ng-template>
    </ng-container>
</div>
